import { render } from "./PosteVoyagePage.vue?vue&type=template&id=364eda68"
import script from "./PosteVoyagePage.vue?vue&type=script&lang=js"
export * from "./PosteVoyagePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__